import angular from "angular";
import template from "./admin-campus-view-vehicle.html";
import AdminSchoolLocationViewVehiclesViewController from "./admin-campus-view-vehicle.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.schools.view.locations.view.vehicles.view",
    {
      url: "/view/:vehicleId",
      controller: AdminSchoolLocationViewVehiclesViewController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.view.vehicles.view", [])
  .config(config)
  .controller(
    "AdminSchoolLocationViewVehiclesViewController",
    AdminSchoolLocationViewVehiclesViewController,
  );
